import type { RouteRecordRaw } from 'vue-router';

import { RouteName } from '@/core/router/RouteName';

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.ACTUALITES,
    path: '/actualites',
    component: () => import('@/domains/actualites/views/ActualitesPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: RouteName.ACTUALITES_SINGLE,
    path: `/actualites/:slug`,
    component: () => import('@/domains/actualites/views/ActualiteDetailsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default routes;
